<ion-list>
  @for (log of auditLogs; track log.orderAuditLogId) {
    <ion-item>
      <ion-text class="ion-text-wrap">
        <p>{{ log.humanReadableMessage }}</p>
      </ion-text>
    </ion-item>
  }
</ion-list>

@if (loading) {
  <div class="ion-text-center ion-padding">
    <ion-spinner></ion-spinner>
  </div>
}

@if (hasMore && !loading) {
  <ion-button (click)="loadMore()" expand="block" fill="outline">Load More</ion-button>
}

@if (!loading && auditLogs.length === 0) {
  <p class="ion-text-center ion-padding">No audit logs found</p>
}
